// @flow

import React from 'react';

import ForbiddenImg from '../../img/errorpage-403.svg';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const ForbiddenPage: any = () => (
  <div className="errorpage-wrapper text-center">
    <div className="errorpage-illustration">
      <div className="errornumber">
        <h1>403</h1>
      </div>
      <div className="errorgraphic">
        <img src={ForbiddenImg} alt="forbidden" />
      </div>
    </div>
    <div className="errorpage-message">
      <h2>
        <FormattedMessage {...messages.header} />
      </h2>
      <p>
        <FormattedMessage {...messages.message} />
        <br /> <FormattedMessage {...messages.message2} />
      </p>
      <p>
        <Button className="btn-tertiary" href="/">
          <FormattedMessage {...messages.button} />
        </Button>
      </p>
    </div>
  </div>
);

export default ForbiddenPage;
